import { EventType } from '@core/models';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, Button, Chip, ColorPaletteProp, IconButton, Sheet, Table } from '@mui/joy';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import { Symbol } from 'components/Symbol';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useStore } from 'store/StoreContext';
import { TradeEvent } from 'store/domain/trade-events/trade-events';

export const TradeEventTable = observer(() => {
  const { tradeEvents } = useStore();

  useEffect(() => {
    tradeEvents.fetchEvents();
    console.log('tradeEvents.fetchEvents()');
  }, [tradeEvents]);

  return (
    <>
      <Sheet sx={{ paddingBottom: 4 }}>
        <Table size="lg">
          <thead>
            <tr>
              <th style={{ width: 40 }} aria-label="empty" />
              <th>Symbol</th>
              <th>Trader</th>
              <th>Type</th>
              <th>% change</th>
              {/* <th>PNL</th>
              <th>ROE</th> */}
            </tr>
          </thead>
          <tbody>
            {tradeEvents.events.map(event => <Row key={event.id} event={event} />)}
          </tbody>
        </Table>
      </Sheet>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        padding: 3,
        marginBottom: 4,
      }}
      >
        <Button
          disabled={!tradeEvents.hasMore}
          onClick={() => tradeEvents.fetchEvents()}
          size="lg"
          variant="soft"
        >
          Load more
        </Button>
      </Box>
    </>
  );
});


export const Row = observer(({ event: { trader, symbol, type, amountChange, markPrice, percentageChange, leverage, pnl, formattedRoe, amount, long, formattedDate, isProfitable } }: PropsWithChildren<{ event: TradeEvent }>) => {
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <tr>
        <td>
          <IconButton
            aria-label="expand row"
            variant="plain"
            color="neutral"
            size="sm"
            onClick={() => setOpen(!isOpen)}
          >
            {isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </td>
        <td>
          <Symbol symbol={symbol} leverage={leverage} isLong={long} />
        </td>
        <td>
          {trader.name}
        </td>
        <td>
          <Chip color={type === EventType.INCREASE || type === EventType.OPEN ? 'success' : 'danger'}>
            {type}
          </Chip>
        </td>
        <td>
          <Typography color={type === EventType.INCREASE || type === EventType.OPEN ? 'success' : 'danger'}>
            {percentageChange}
          </Typography>
        </td>
        {/* <td>
      {pnl}
    </td>
    <td>
      {formattedRoe}
    </td> */}
      </tr>
      {isOpen && (
        <tr>
          <td
            style={{
              height: 0,
              padding: 0,
            }} colSpan={5}
          >
            <Sheet
              variant="soft"
              sx={{
                p: 1,
                pl: 6,
                boxShadow: 'inset 0 3px 6px 0 rgba(0 0 0 / 0.08)',
                display: 'flex',
                gap: 1,
              }}
            >
              <ExtraInfoCard title="Date" description={formattedDate} />
              <ExtraInfoCard title="At price" description={markPrice} />
              <ExtraInfoCard title="Amt change" description={amountChange.toFixed(2)} />
              <ExtraInfoCard title="Amt" description={amount} />
              <ExtraInfoCard title="PnL" description={pnl} descriptionColor={isProfitable ? 'success' : 'danger'} />
              <ExtraInfoCard title="ROE" description={formattedRoe} descriptionColor={isProfitable ? 'success' : 'danger'} />
            </Sheet>
          </td>
        </tr>
      )}
    </>
  );
});

export const ExtraInfoCard = ({ title, description, descriptionColor }: PropsWithChildren<{ title: string; description: string | number; descriptionColor?: ColorPaletteProp }>) => (
  <Card variant="plain" size="sm">
    <CardContent>
      <Typography level="title-md">
        {title}
      </Typography>
      <Typography color={descriptionColor}>
        {description}
      </Typography>
    </CardContent>
  </Card>
);
